import { IAuthRegisterErrorData } from '@smuchile/pkg-unimarc-hooks/shared/interfaces'

export const getErrorRetryAfter = (error: IAuthRegisterErrorData) => {
  if (error.error?.meta?.retryAfter) {
    return error.error?.meta?.retryAfter
  }

  return 0
}
